import Vue from 'vue';
import VueRouter from 'vue-router';

/* 共用 Start -------------------*/
import Index from '../views/index/Index';
import MyCenter from '../views/myCenter/Index';
import MessageSetting from '../views/message/Setting';
/* 共用 End -------------------*/

/* 会员相关 Start -------------------*/
import MeIndex from '../views/index/MeIndex';
import ResumeIndex from '../views/resume/Index';
import ResumeNew from '../views/resume/New';
import ProfessionalResume from '../views/resume/ProfessionalResume';
import OrderPay from '../views/resume/OrderPay';
/* 会员相关 End -------------------*/

/* 人事相关 Start-------------------- */
import HrIndex from '../views/index/HrIndex';
import MyCompany from '../views/myCenter/MyCompany';
import UploadLicence from '../views/hr/UploadLicence';
import VerifyFail from '../views/hr/VerifyFail';
import VerifyWait from '../views/hr/VerifyWait';

import JobIndex from '../views/job/Index';
import JobDetail from '../views/job/Detail';
import JobEdit from '../views/job/Edit';

import TalentIndex from '../views/talent/Recommend';
import TalentSearch from '../views/talent/Index';
import TalentDetail from '../views/talent/Detail';
import HrDownloadResume from '../views/talent/myDownload/Index';
import HrInsteadInviteResume from '../views/talent/myInsteadInvite/Index';
import HrReadResume from '../views/talent/myRead/Index';

import HrChat from '../views/message/HrChat';
import HrSystemMessage from '../views/message/HrSystem';
import PreviewResume4Mail from '../views/market/PreviewResume4Mail';
import Interview from '../views/interview/Index';
import InterviewDetail from '../views/interview/Detail';
/* 人事相关 End-------------------- */

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '乐跳网'
    }
  },
  {
    path: '/MeIndex',
    name: 'MeIndex',
    component: MeIndex,
    meta: {
      title: '乐跳网'
    }
  },
  {
    path: '/HrIndex',
    name: 'HrIndex',
    component: HrIndex,
    meta: {
      title: '乐跳网'
    }
  },
  {
    path: '/MyCenter',
    name: 'MyCenter',
    component: MyCenter,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },{
    path: '/MyCompany',
    name: 'MyCompany',
    component: MyCompany,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },

  {
    path: '/ResumeIndex',
    name: 'ResumeIndex',
    component: ResumeIndex,
    meta: { 
      requiresAuth: true,
      userRole: 'me',
      title: '乐跳网'
    }
  },
  {
    path: '/ResumeNew',
    name: 'ResumeNew',
    component: ResumeNew,
    meta: { 
      requiresAuth: true,
      userRole: 'me',
      title: '乐跳网'
    }
  },
  {
    path: '/UploadLicence',
    name: 'UploadLicence',
    component: UploadLicence,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '上传营业执照-乐跳网'
    }
  },
  {
    path: '/VerifyFail',
    name: 'VerifyFail',
    component: VerifyFail,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '审核失败-乐跳网'
    }
  },
  {
    path: '/VerifyWait',
    name: 'VerifyWait',
    component: VerifyWait,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '等待审核-乐跳网'
    }
  },
  {
    path: '/JobIndex',
    name: 'JobIndex',
    component: JobIndex,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '职位管理-乐跳网'
    }
  },
  {
    path: '/JobDetail',
    name: 'JobDetail',
    component: JobDetail,
    meta: { 
      requiresAuth: true,      
      title: '职位详情-乐跳网'
    }
  },
  {
    path: '/JobEdit',
    name: 'JobEdit',
    component: JobEdit,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',      
      title: '发布职位-乐跳网'
    }
  },
  {
    path: '/TalentIndex',
    name: 'TalentIndex',
    component: TalentIndex,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '推荐人才-乐跳网'
    }
  },
  {
    path: '/TalentSearch',
    name: 'TalentSearch',
    component: TalentSearch,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '人才搜索-乐跳网'
    }
  },  
  {
    path: '/TalentDetail',
    name: 'TalentDetail',
    component: TalentDetail,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '人才详情-乐跳网'
    }
  },  
  {
    path: '/HrDownloadResume',
    name: 'HrDownloadResume',
    component: HrDownloadResume,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '已下载人才-乐跳网'
    }
  }, 
  {
    path: '/HrInsteadInviteResume',
    name: 'HrInsteadInviteResume',
    component: HrInsteadInviteResume,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '已代约人才-乐跳网'
    }
  },
  {
    path: '/HrReadResume',
    name: 'HrReadResume',
    component: HrReadResume,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '看过的人才-乐跳网'
    }
  },
  {
    path: '/HrChat',
    name: 'HrChat',
    component: HrChat,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },
  {
    path: '/HrSystemMessage',
    name: 'HrSystemMessage',
    component: HrSystemMessage,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },
  {
    path: '/MessageSetting',
    name: 'MessageSetting',
    component: MessageSetting,
    meta: { 
      requiresAuth: true,
      title: '乐跳网'
    }
  },
  {
    path: '/Interview',
    name: 'Interview',
    component: Interview,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },
  {
    path: '/InterviewDetail',
    name: 'InterviewDetail',
    component: InterviewDetail,
    meta: { 
      requiresAuth: true,
      userRole: 'hr',
      title: '乐跳网'
    }
  },

  
  {
    path: '/ProfessionalResume',
    name: 'ProfessionalResume',
    component: ProfessionalResume,
    meta: { 
      requiresAuth: true,
      title: '乐跳网'
    }
  },
  {
    path: '/OrderPay',
    name: 'OrderPay',
    component: OrderPay,
    meta: { 
      requiresAuth: true,
      title: '乐跳网'
    }
  },
  {
    path: '/PreviewResume4Mail',
    name: 'PreviewResume4Mail',
    component: PreviewResume4Mail,
    meta: {
      title: '乐跳网'
    }
  },
];

const router = new VueRouter({
  base: '/',
  mode: 'hash',
  routes
});

export default router;